import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConstructionPipe = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "construction-pipe" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 21,
			y1: 19.5,
			x2: 21,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9,6.75H8.25a2.25,2.25,0,0,0,0,4.5H13.5a7.513,7.513,0,0,1,7.155,5.25"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 20.25,
			y1: 6.75,
			x2: 12,
			y2: 6.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 2.25,
			x2: 20.25,
			y2: 2.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.482,16.5a2.985,2.985,0,0,0-1.982-.75H8.25a6.75,6.75,0,0,1,0-13.5H9"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 16.5,
			y1: 23.25,
			x2: 16.5,
			y2: 19.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 20.25,
			y1: .75,
			x2: 20.25,
			y2: 8.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9,
			y1: .75,
			x2: 9,
			y2: 8.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15,
			y1: 19.5,
			x2: 22.5,
			y2: 19.5
		})
	]
});
export default SvgConstructionPipe;
